import React, {lazy,Suspense} from 'react'
import {  BrowserRouter,IndexRoute} from  'react-router-dom'
import {Switch,Route} from 'react-router'

import Header  from './components/Header'

import About from './views/About'

import Home from './views/Home'

import {AddressesCom} from './containers'
import { ReguserContainerCom} from './containers'
/*


 <Route exact path="/myaccountSV/:id"  component={ReguserContainerCom}  />

 <Route exact path="/myaccountSV/:id"  component={ReguserContainerCom}  />

*/

class SVApp extends React.Component{

  render(){
    return (<BrowserRouter>
      <Header/>
      <Suspense>
        <Switch>
          <Route exact path="/" component={Home}  />
          <Route exact path="/about" component={About}  />
          <Route exact path="/svaddrs" component={AddressesCom} >
          <Route exact path="/myaccountSV"  component={ReguserContainerCom}  />

       
         
         
                           
        </Route>
                 

        </Switch>
      </Suspense>
    </BrowserRouter>)
  }
  
}

export default SVApp